import axios from 'axios/index'
import Vuex from 'vuex'
import Vue from 'vue'
import { Validator } from 'vee-validate'
import apiUrl from '../api/openstack/_const'
import snapshots from './modules/snapshots'
import user from './modules/user'
import keypairs from './modules/keypairs'
import flavors from './modules/flavors'
import floating from './modules/floating'
import images from './modules/images'
import computes from './modules/computes'
import billing from './modules/billing'
import securitygroups from './modules/securitygroups'
import securitygrouprules from './modules/securitygrouprules'
import modal from './modules/modal'
import volumes from './modules/volumes'

// Global Variables
Vue.prototype.$globalEnv = {apiUrl: apiUrl.API_URL}

const state = {
  loadingState: false,
  locale: {},
  defaultLang: 'de'
}
const getters = {
  getLoadingState: (state) => {
    return state.loadingState
  }
}
const actions = {
  getAuthUser: ({ commit }, data) => {
    return axios.post(apiUrl.AUTH_URL + data.cid, {
      password: data.password
    })
  },
  getTranslation: ({ commit }, data) => {
    if (typeof window.sessionStorage.defaultLang === 'undefined') {
      window.sessionStorage.setItem('defaultLang', state.defaultLang)
    }
    axios.get(apiUrl.LANG_URL + window.sessionStorage.defaultLang).then((response) => {
      commit('SET_locale', JSON.parse(JSON.stringify(response.data)))
    }).catch((error) => {
      console.log(error)
    })
  }
}
const mutations = {
  SET_locale (state, data) {
    state.locale = data
  },
  SET_defaultLang (state, data) {
    state.defaultLang = data
    Validator.localize(data) // Set Language for basic translation
  },
  setLoadingState (state, data) {
    state.loadingState = data
  }
}

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    billing,
    computes,
    images,
    keypairs,
    flavors,
    floating,
    snapshots,
    securitygroups,
    securitygrouprules,
    user,
    modal,
    volumes
  },
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js